// eslint-disable-next-line import/prefer-default-export
export const VALIDATION = {
  fieldComplete: 'Le champs suivant doit être renseigné :',
  fieldsComplete: 'Les champs suivants doivent être renseignés :',
  stringLength: {
    fieldWithMin: 'Le champ "{name}" doit posséder entre {min} et {max} caractères.',
    intituleWithMinMax: 'Le champ "Intitule" de l\'adresse postale doit posséder entre {min} et {max} caractères.',
    adressVilleWithMinMax: 'Le champ "Ville" de l\'adresse postale doit posséder entre {min} et {max} caractères.',
    fieldWithMinIsOne: 'Le champ "{name}" est obligatoire.',
    field: 'Le champ "{name}" doit contenir moins de {max} caractères.',
  },
  formatDate: {
    withoutTime: 'Le format de la date "{name}" n\'est pas bon. Il doit etre JJ/MM/AAAA.',
  },
  dateDebutGreaterDateFin: 'La date de début est plus grande que la date de fin',
  decimal: 'Le décimal numérique "{name}" n\'est pas correct.',
  dateRequired: 'Le champ "{name}" est obligatoire.',
  addressRequired: 'L\'adresse est obligatoire.',
  addressIntitituleRequired: 'Le champ adresse postale est obligatoire.',
  addressVilleRequired: 'Le champ ville est obligatoire.',
  addressWithIntituleWrongFormat: 'Si un champ de l\'adresse est saisi, l\'intitulé 1 et la ville doivent l\'être aussi.',
  addressWrongFormat: 'Si un champ de l\'adresse est saisi, la ville doit l\'être aussi',
  internalError: 'Erreur interne',
  logFail: 'Erreur de connexion',
  range: {
    positif: 'Le champ "{name}" doit être positif.',
    positifObligatoire: 'Le champ "{name}" doit être positif et obligatoire.',
    default: 'Le champ "{name}" doit être compris entre les valeurs {min} et {max}.',
  },
  destCompt: 'Le destinataire comptable est obligatoire',
  libelleObligatoire: 'Le libellé est obligatoire',
  requiredField: {
    libelle: 'Libellé',
  },
  latitude: 'Latitude',
  longitude: 'Longitude',
  amountGreaterThanMouvements: 'Le montant ne peut être supérieur à celui des mouvements',
  requestWasNotPassed: 'La requête n\'est pas passée chez Oodrive',
  password: 'Mot de passe',
  email: 'Email',
  site: 'Site',
  impressionAfficheProduitId: 'Produit impression affiche',
  notAccess: 'Vous n\'avez pas acccés à l\'application',
  secteurRequired: 'Le secteur est obligatoire',
  fieldIsNotInteger: 'Le champ "{name}" n\'est pas un nombre entier',
  fieldIsNotDecimal: 'Le champ "{name}" n\'est pas un nombre décimal',
};
